import { z } from 'zod';
import { cognitoPasswordSchema } from './cognitoPassword';

export const requestResetPasswordSchema = z.object({
  username: z.string().email('Invalid email address'),
});

export type RequestResetPasswordFormType = z.infer<
  typeof requestResetPasswordSchema
>;

export const sendNewPasswordSchema = z.object({
  verificationCode: z
    .string()
    .length(6, 'Verification code must be 6 characters'),
  newPassword: cognitoPasswordSchema,
  username: z.string().email('Invalid email address'),
});

export type SendNewPasswordFormType = z.infer<typeof sendNewPasswordSchema>;

export const updatePasswordResponseSchema = z
  .object({
    oldPassword: cognitoPasswordSchema,
    newPassword: cognitoPasswordSchema,
    username: z.string(),
  })
  .refine((data) => data.oldPassword !== data.newPassword, {
    message: 'New password must be different from the current password',
    path: ['newPassword'],
  });

export type UpdatePasswordResponseType = z.infer<
  typeof updatePasswordResponseSchema
>;
